import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { HeaderStepRouteEnum, STEPS_STORE } from "../constants/constant";
import { StepTypeEnum, StepsType } from "src/types";
import { TFunction } from "i18next";

const initialStepsState = {
  steps: [],
  currentId: "insurance",
  isPageLoading: false,
};

export const useStepStore = create(
  devtools(
    persist<StepsType>(
      (set) => ({
        ...initialStepsState,
        setSteps: (type: StepTypeEnum, t: TFunction) => {
          try {
            set(() => ({
              steps:
                type === StepTypeEnum.AOV_ACTURE
                  ? []
                  : assignStepsByStepType(type, t),
            }));
          } catch (err: any) {
            const error = err || "Unexpected error.";
            throw error;
          }
        },
        setCurrentStepId: (id: string) => {
          try {
            set(() => ({
              currentId: id,
            }));
          } catch (err: unknown) {
            const error = err || "Unexpected error.";
            throw error;
          }
        },
        setIsPageLoading: (value: boolean) => {
          try {
            set(() => ({
              isPageLoading: value,
            }));
          } catch (err: unknown) {
            const error = err || "Unexpected error.";
            throw error;
          }
        },
        clearSteps: () => {
          set(() => initialStepsState);
        },
      }),
      {
        name: STEPS_STORE,
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);

const assignStepsByStepType = (type: StepTypeEnum, t: TFunction) => {
  switch (type) {
    case StepTypeEnum.AOV:
      return [
        {
          id: HeaderStepRouteEnum.INSURANCE,
          title: t("header.steps.insurances"),
          widthPercentage: "25%",
          mobileWidthPercentage: "25%",
        },
        {
          id: HeaderStepRouteEnum.KNOWLEDGE_TEST,
          title: t("header.steps.knowledgeTest"),
          widthPercentage: "25%",
          mobileWidthPercentage: "25%",
        },
        {
          id: HeaderStepRouteEnum.MEDICAL_HISTORY,
          title: t("header.steps.medicalHistory"),
          widthPercentage: "25%",
          mobileWidthPercentage: "25%",
        },
        {
          id: HeaderStepRouteEnum.CHECKOUT,
          title: t("header.steps.checkout"),
          widthPercentage: "25%",
          mobileWidthPercentage: "25%",
        },
      ];
    case StepTypeEnum.CALCULATOR:
      return [
        {
          id: HeaderStepRouteEnum.INSURANCE,
          title: t("header.steps.insurances"),
          widthPercentage: "30%",
          mobileWidthPercentage: "25%",
        },
        {
          id: HeaderStepRouteEnum.CALCULATE,
          title: t("header.steps.calculate"),
          widthPercentage: "50%",
          mobileWidthPercentage: "50%",
        },
        {
          id: HeaderStepRouteEnum.RESULT,
          title: t("header.steps.result"),
          widthPercentage: "20%",
          mobileWidthPercentage: "25%",
        },
      ];
    case StepTypeEnum.CONSUMER_INSURANCE:
      return [
        {
          id: HeaderStepRouteEnum.CONSUMER_PREMIUM,
          title: t("header.steps.carInsurance.premium"),
          widthPercentage: "30%",
          mobileWidthPercentage: "25%",
        },
        {
          id: HeaderStepRouteEnum.CONSUMER_USER_INFO,
          title: t("header.steps.carInsurance.options"),
          widthPercentage: "30%",
          mobileWidthPercentage: "25%",
        },
        {
          id: HeaderStepRouteEnum.CONSUMER_FORMALITIES,
          title: t("header.steps.carInsurance.formalities"),
          widthPercentage: "20%",
          mobileWidthPercentage: "25%",
        },
        {
          id: HeaderStepRouteEnum.CONSUMER_PAYMENT,
          title: t("header.steps.carInsurance.payment"),
          widthPercentage: "20%",
          mobileWidthPercentage: "25%",
        },
      ];
    default:
      return [
        {
          id: HeaderStepRouteEnum.INSURANCE,
          title: t("header.steps.insurances"),
          widthPercentage: "30%",
          mobileWidthPercentage: "25%",
        },
        {
          id: HeaderStepRouteEnum.PERSONALISE,
          title: t("header.steps.personalise"),
          widthPercentage: "50%",
          mobileWidthPercentage: "50%",
        },
        {
          id: HeaderStepRouteEnum.CHECKOUT,
          title: t("header.steps.checkout"),
          widthPercentage: "20%",
          mobileWidthPercentage: "25%",
        },
      ];
  }
};
